/*
 * The "/#join" CTAs (Join Free / Create your profile / Join as a Mentor or
 * Mentee) open the Sign Up pop-up where the visitor already is, instead of
 * routing to /register first.
 *
 * The signal lives in this module rather than a React context because Link
 * renders in three different trees — RevampShell, LegacyShell and the bare
 * partner pages — and a context would be missing from some of them.
 */
export const JOIN_HREF = "/#join";
export const LOGIN_HREF = "/#login";

export function isJoinHref(href) {
  return href === JOIN_HREF;
}

export function isGuestAuthHref(href) {
  return href === JOIN_HREF || href === LOGIN_HREF;
}

let listener = null;

export function openSignUp() {
  if (listener) listener();
}

// SignUpModalHost subscribes; only one host is mounted (src/App/index.js).
export function onOpenSignUp(fn) {
  listener = fn;
  return () => {
    if (listener === fn) listener = null;
  };
}
